module.exports = __webpack_public_path__ + "img/02.63aecb15.jpg";